import { addDataset } from '../../apiClient';
import { notifications } from '@mantine/notifications';
import { useEntityQueryUpdate } from '../../../hooks/useEntityQueryUpdate';
import { useMutation } from '@tanstack/react-query';

const useAddDataset = () => {
    const entityUpdater = useEntityQueryUpdate();

    const mutation = useMutation({
        mutationKey: 'add_dataset',
        mutationFn: (model) => addDataset(model),
        onSuccess: (data, variables) => {
            entityUpdater([['data_sets'], ['data_set', data.id]], data);
            const message = variables?.id
                ? 'Successfully updated dataset'
                : 'Successfully created dataset';
            notifications.show({
                title: 'Success',
                message: message,
                color: 'green',
            });
        },
        onError: (error) => {
            notifications.show({
                title: 'Error',
                message: error.message,
                color: 'red',
            });
        },
    });
    return mutation;
};
export default useAddDataset;
